/* yl-back.js — the app-style back arrow at the start of every breadcrumb (2026-11-02).
   User: "例如我筛选了一批商品，进入详情再返回，应该还是之前的商品列表，返回的是之前带搜索条件的url".
   - Came from a page on this site → history.back(): the browser restores the filtered URL and scroll position.
   - Opened from outside (search engine, shared link, new tab) → go to the nearest breadcrumb parent instead of
     leaving the site; the link's href is set to that parent so no-JS and middle-click behave the same way. */
(function () {
  'use strict';

  function cameFromThisSite() {
    if (window.history.length < 2 || !document.referrer) return false;
    try {
      var ref = new URL(document.referrer);
      return ref.origin === window.location.origin && ref.href !== window.location.href;
    } catch (_) {
      return false;
    }
  }

  function init() {
    document.querySelectorAll('[data-yl-back]').forEach(function (link) {
      var crumbs = link.closest('.yl-breadcrumbs');
      var parents = crumbs ? crumbs.querySelectorAll('.yl-breadcrumbs__list a.yl-breadcrumbs__link') : [];
      if (parents.length) link.href = parents[parents.length - 1].href;
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-yl-back]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!cameFromThisSite()) return;
    event.preventDefault();
    window.history.back();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
